import styled from 'styled-components';
import { FontWeights, Colors } from '../../../consts';
import { sansSerif } from '../../../helpers';
export var FloatingLabelBaseSkin = styled.label.withConfig({
  displayName: "FloatingLabelBaseskin__FloatingLabelBaseSkin",
  componentId: "gpof2s-0"
})(["", ";font-weight:", ";margin:0;font-size:16px;line-height:18px;letter-spacing:0.00937em;text-decoration:inherit;text-transform:inherit;position:absolute;bottom:8px;left:0;transform-origin:left top;transition:transform 0.15s cubic-bezier(0.4,0,0.2,1),color 0.15s cubic-bezier(0.4,0,0.2,1);cursor:text;color:", ";transform:", ";"], sansSerif, FontWeights.REGULAR, function (_ref) {
  var disabled = _ref.disabled,
      floatAbove = _ref.floatAbove,
      active = _ref.active,
      showError = _ref.showError;
  return !disabled ? floatAbove ? showError ? Colors.RED : active ? Colors.BLUE : '#666' : '#666' : '#ababab';
}, function (_ref2) {
  var floatAbove = _ref2.floatAbove;
  return floatAbove && 'translateY(-100%) scale(0.75)';
});